import { gql } from "@apollo/client"

export const SEARCH_FILTER_OPTIONS = gql`
  query SearchFilterOptions($data: SearchFilterOptionsInput!) {
    searchFilterOptions(data: $data) {
      options {
        id
        name
        state
        districtId
        schoolId
        classIds
      }
      totalCount
      hasMore
    }
  }
`

export const INITIALIZE_FILTERS = gql`
  query InitializeFilters($data: FilterInitializationInput!) {
    initializeFilters(data: $data) {
      districts {
        id
        name
        state
      }
      schools {
        id
        name
        state
        districtId
      }
      teachers {
        id
        name
        state
        districtId
        schoolId
      }
      classes {
        id
        name
        state
        districtId
        schoolId
        teacherIds
      }
      students {
        id
        name
        state
        districtId
        schoolId
        classIds
      }
    }
  }
`
